/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Header_Ai_Api_Keys_LabelInputs */

const en_common_header_ai_api_keys_label = /** @type {(inputs: Common_Header_Ai_Api_Keys_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API Keys`)
};

const zh_common_header_ai_api_keys_label = /** @type {(inputs: Common_Header_Ai_Api_Keys_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API 密钥`)
};

/**
* | output |
* | --- |
* | "API Keys" |
*
* @param {Common_Header_Ai_Api_Keys_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_header_ai_api_keys_label = /** @type {((inputs?: Common_Header_Ai_Api_Keys_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Header_Ai_Api_Keys_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_header_ai_api_keys_label(inputs)
	return zh_common_header_ai_api_keys_label(inputs)
});
export { common_header_ai_api_keys_label as "common.header.ai.api_keys.label" }